var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NavBarApps pt-4"},[_vm._m(0),_c('a',{staticClass:"d-flex align-items-center px-4",attrs:{"href":_vm.monitoringUrl,"target":"_blank","rel":"noopener"}},[_c('i',{staticClass:"far fa-fw fa-chart-line mr-3"}),_c('span',[_vm._v("Monitoring")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"px-4"},[_c('strong',[_vm._v("Apps")])])
}]

export { render, staticRenderFns }